import { Component, OnChanges, Input } from "@angular/core";

import { APIResults } from "src/app/sharedinterfaces";
import { ApiService } from "src/app/api.service";

@Component({
	selector: "app-mech-firmware",
	templateUrl: "./mech-firmware.component.html",
	styleUrls: ["./mech-firmware.component.scss"]
})
export class MechFirmwareComponent implements OnChanges {
	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	fleet: APIResults.Fleet;
	@Input()
	components: APIResults.AssetComponentList;

	public devices: APIResults.FirmwareStatus[];
	public optime: Date;

	constructor(public api: ApiService) { }

	async ngOnChanges() {
		await this.updateFirmware();
	}

	async updateFirmware() {
		const result = await this.api.GetFirmware(this.asset.asset_id);
		this.devices = result.devices;
		this.optime = result.ts;
	}
}
